import { createContext, type RefObject, useContext } from "react";

const SectionSelectPortalContext =
  createContext<RefObject<HTMLDivElement | null> | null>(null);

export const SectionSelectPortalProvider = SectionSelectPortalContext.Provider;

export const useSectionSelectPortal = () =>
  useContext(SectionSelectPortalContext);
